import { Box, Flex } from "@chakra-ui/react"
import Button from "@pathwright/ui/src/components/button/Button"
import Text from "@pathwright/ui/src/components/ui/Text"
import BrowseCourses from "@pathwright/web/src/modules/library/browse/BrowseCourses"
import LIBRARY_RESOURCES_QUERY from "@pathwright/web/src/modules/library/graphql/library-resources-query"
import {
  flattenEdges,
  useQuery
} from "@pathwright/web/src/modules/utils/apollo"
import { getStoreResourceUrl } from "@pathwright/web/src/modules/utils/urls"

const RelatedCourses = ({ categories, resource }) => {
  const categoryIds = categories.map((category) => category.id)

  const coursesQuery = useQuery(LIBRARY_RESOURCES_QUERY, {
    variables: {
      idFilter: { neq: resource.id },
      categoryIdFilter: { in: categoryIds },
      resourceTypeFilter: { eq: "course" },
      orderBy: "list_order,-created",
      first: 10
    }
  })

  const courses = flattenEdges(coursesQuery?.data?.resources || [])

  if (!courses?.length) return null

  const getResourceTo = (resource) => ({
    pathname: getStoreResourceUrl(resource.slug),
    state: { setResourceLaunchedFrom: true }
  })

  const getResourceSettingsTo = (resource) => null

  return (
    <Box w="full" maxW="1100px" m="0 auto">
      <Box py={10} px="30px" borderTop="1px" borderColor="rgba(0,0,0,0.1)">
        <Flex mb={4} justify="start" align="center" wrap="wrap">
          <Text.H5 style={{ marginBottom: "5px", marginRight: "5px" }}>
            More in{" "}
          </Text.H5>
          {categories.map((category) => (
            <Button
              key={category.id}
              to={`/library/?category=${category.name}`}
              style={{
                padding: "0.5rem 0.8rem",
                borderRadius: "8px",
                margin: "0 5px 5px 0"
                // borderBottom: "1px solid var(--school-main-color)"
              }}
              styleType="secondary"
            >
              {category.name}
            </Button>
          ))}
        </Flex>
        <BrowseCourses
          getCourseTo={getResourceTo}
          getCourseSettingsTo={getResourceSettingsTo}
          courses={courses}
        />
      </Box>
    </Box>
  )
}

export default RelatedCourses
